import { FormattedMessage } from 'dibs-react-intl';

export const deliveryTitle = (
    <FormattedMessage id="pdpBlurb.deliveryTitle" defaultMessage="Shipping" />
);

export const leadTimeTitle = (
    <FormattedMessage
        key="leadTimeTitle"
        id="pdpBlurb.leadTimeTitle"
        defaultMessage="Estimated Production Time"
    />
);

export const dyoTitle = (
    <FormattedMessage id="pdpBlurb.dyoTitle" defaultMessage="Design Your Own" />
);

export const dyoDetail = (
    <FormattedMessage
        id="pdpBlurb.dyoDetail"
        defaultMessage="Collaborate with the seller to create a bespoke piece featuring this gemstone."
    />
);

export const rareFindTitle = (
    <FormattedMessage key="rareFindTitle" id="pdpBlurb.rareFindTitle" defaultMessage="Rare Find" />
);
